import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Component({
  standalone: false,
  selector: 'dsp-privacy',
  templateUrl: 'privacy.component.html',
  styleUrls: [ 'privacy.component.scss' ]
})
export class PrivacyBannerComponent implements OnInit {
  public open$: BehaviorSubject<boolean> = new BehaviorSubject(true);

  public constructor() {}

  public ngOnInit(): void {
    this.getPrivacyCookie();
  }

  getPrivacyCookie(): void {
    this.open$.next(decodeURIComponent(document.cookie).indexOf('cookieConsent=true') === -1);
  }

  onPrivacyClick(): void {
    document.cookie = 'cookieConsent=true;secure;';
    this.getPrivacyCookie();
  }
}
